import React from 'react';
import ReactSelect, { components } from 'react-select';
import AsyncSelect from 'react-select/lib/Async';
import { colorSchema } from 'utils/style';

const SingleValue = ({ children, selectProps: { subLabel }, ...props }) => (
  <components.SingleValue {...props}>
    {children} <span className="sub-text"> {subLabel}</span>
  </components.SingleValue>
);

const ValueContainer = ({ children, selectProps, ...props }) => {
  const { classNamePrefix, label } = selectProps;
  return (
    <components.ValueContainer selectProps={selectProps} {...props}>
      {!!label && <div className={`${classNamePrefix}__label`}>{label} </div>}
      {children}
    </components.ValueContainer>
  );
};

const Placeholder = ({ children, ...props }) => {
  const { selectProps } = props;
  const { menuIsOpen, focusedPlaceholder } = selectProps;
  return (
    <components.Placeholder {...props}>
      {!menuIsOpen || !focusedPlaceholder ? children : focusedPlaceholder}
    </components.Placeholder>
  );
};

const IndicatorSeparator = () => null;

const defaultComponents = {
  SingleValue,
  ValueContainer,
  Placeholder,
  IndicatorSeparator,
};

const Select = ({
  async,
  components: overrideComponents,
  className,
  classNameOverride,
  theme,
  invalid,
  error,
  dataE2E,
  externalStyles,
  ...props
}) => {
  const inValidStyles = (isInvalid, hasError) =>
    hasError
      ? {
          background: colorSchema('redWattermelon')({ theme }),
          borderColor: `${colorSchema('redCherry')({ theme })}!important`,
        }
      : isInvalid
      ? {
          background: colorSchema('yellowBanana')({ theme }),
          borderColor: `${colorSchema('orangePeach')({ theme })}!important`,
        }
      : {};

  const customStyles = {
    control: (provided) => ({
      ...provided,
      ...inValidStyles(invalid, error),
    }),
    ...externalStyles,
  };

  const selectProps = {
    classNamePrefix: classNameOverride || className,
    className: `e2e-${dataE2E || ''}`,
    components: { ...defaultComponents, ...overrideComponents },
    styles: { ...customStyles },
    ...props,
  };

  if (async) {
    return <AsyncSelect {...selectProps} />;
  }

  return <ReactSelect {...selectProps} />;
};

export default Select;
export { components };
